export const navItems = [
  {
    label: "Ana Sayfa",
    href: "/",
  },
  {
    label: "Kurumsal",
    href: "/kurumsal",
    children: [
      { label: "Hakkımızda", href: "/kurumsal/hakkimizda" },
      { label: "Başkanın Mesajı", href: "/kurumsal/baskandan-mesaj" },
      { label: "Yönetim Kurulu", href: "/kurumsal/yonetim-kurulu" },
    ],
  },
  {
    label: "Tarihçe ve Hafıza",
    href: "/tarihce",
    children: [
      { label: "Trabzon'un Tarihi", href: "/tarihce/tarih" },
      { label: "Derneğin Hikâyesi", href: "/tarihce/hikaye" },
      { label: "Kurucular ve Emek Verenler", href: "/tarihce/kurucular" },
      { label: "Fotoğraf Arşivi", href: "/tarihce/arsiv" },
      { label: "Trabzon Kültürü", href: "/tarihce/kultur" },
    ],
  },
  {
    label: "Faaliyetler",
    href: "/faaliyetler",
    children: [
      { label: "Etkinlik Takvimi", href: "/faaliyetler/etkinlikler" },
      { label: "Haberler", href: "/faaliyetler/haberler" },
      { label: "Projeler", href: "/faaliyetler/projeler" },
    ],
  },
  {
    label: "Topluluk",
    href: "/topluluk",
    children: [
      { label: "Gençlik", href: "/topluluk/genclik" },
      { label: "Kadınlar ve Aile", href: "/topluluk/kadin-aile" },
      { label: "Öğrenciler", href: "/topluluk/ogrenciler" },
      { label: "İş İnsanları / Meslek Ağı", href: "/topluluk/meslek-agi" },
    ],
  },
  {
    label: "Destek ve Katılım",
    href: "/destek",
    children: [
      { label: "Üyelik", href: "/destek/uyelik" },
      { label: "Anlaşmalı Kurumlar", href: "/destek/avantajlar" },
      { label: "Gönüllülük", href: "/destek/gonulluluk" },
      { label: "Burs / Sosyal Destek", href: "/destek/burs" },
      { label: "Sponsorluk", href: "/destek/sponsorluk" },
    ],
  },
  {
    label: "Medya",
    href: "/medya",
    children: [
      { label: "Galeri", href: "/medya/galeri" },
      { label: "Video", href: "/medya/video" },
      { label: "Basında Biz", href: "/medya/basin" },
    ],
  },
  {
    label: "İletişim",
    href: "/iletisim",
  },
];

export const boardMembers = [
  {
    id: 1,
    name: "Orhan Aygün",
    role: "Dernek Başkanı",
    image: "/baskan-foto.jpg",
    message:
      "Trabzon'dan Bursa'ya taşıdığımız değerler, sadece nostaljimiz değil; geleceğimizin temelidir.",
  },
  {
    id: 2,
    name: "Hakkı Üçüncü",
    role: "Başkan Vekili",
    image: "",
  },
  {
    id: 3,
    name: "Ayhan Karaca",
    role: "Genel Sekreter",
    image: "",
  },
  {
    id: 4,
    name: "Ömer Salih Erdoğan",
    role: "Sayman",
    image: "",
  },
  {
    id: 5,
    name: "Caner Şenocak",
    role: "Lokal Amiri",
    image: "",
  },
  { id: 6,  name: "Alpaslan Odabaş",   role: "Başkan Yardımcısı", image: "" },
  { id: 7,  name: "Celil Çolak",        role: "Başkan Yardımcısı", image: "" },
  { id: 8,  name: "Erdal Yıldız",       role: "Başkan Yardımcısı", image: "" },
  { id: 9,  name: "Erdoğan Akyıldız",   role: "Başkan Yardımcısı", image: "" },
  { id: 10, name: "Erkan Yılmaz",       role: "Başkan Yardımcısı", image: "" },
  { id: 11, name: "Gökhan Özkul",       role: "Başkan Yardımcısı", image: "" },
  { id: 12, name: "Gökhan Şahin",       role: "Başkan Yardımcısı", image: "" },
  { id: 13, name: "Hakan Baksoy",       role: "Başkan Yardımcısı", image: "" },
  { id: 14, name: "Mehmet Nezor",       role: "Başkan Yardımcısı", image: "" },
  { id: 15, name: "Metin Akyıldız",     role: "Başkan Yardımcısı", image: "" },
  { id: 16, name: "Metin Çoraklı",      role: "Başkan Yardımcısı", image: "" },
  { id: 17, name: "Muhammet Gündoğan",  role: "Başkan Yardımcısı", image: "" },
  { id: 18, name: "Mustafa Berber",     role: "Başkan Yardımcısı", image: "" },
  { id: 19, name: "Osman Gündoğan",     role: "Başkan Yardımcısı", image: "" },
  { id: 20, name: "Osman Kalaycı",      role: "Başkan Yardımcısı", image: "" },
  { id: 21, name: "Ömer Ertürk",        role: "Başkan Yardımcısı", image: "" },
  { id: 22, name: "Recep Aydın",        role: "Başkan Yardımcısı", image: "" },
  { id: 23, name: "Samet Kurumahmut",   role: "Başkan Yardımcısı", image: "" },
  { id: 24, name: "Sefa Koz",           role: "Başkan Yardımcısı", image: "" },
  { id: 25, name: "Servet Yılmaz",      role: "Başkan Yardımcısı", image: "" },
  { id: 26, name: "Süleyman Uzun",      role: "Başkan Yardımcısı", image: "" },
  { id: 27, name: "Tahir Kahveci",      role: "Başkan Yardımcısı", image: "" },
  { id: 28, name: "Turan Danışmaz",     role: "Başkan Yardımcısı", image: "" },
  { id: 29, name: "Zeki Veli",          role: "Başkan Yardımcısı", image: "" },
  { id: 30, name: "Ziya Aşkar",         role: "Başkan Yardımcısı", image: "" },
];

export const denetlemeKurulu = [
  { id: 1, name: "Kemal Gür", role: "Denetleme Kurulu" },
  { id: 2, name: "Cesur Nezor", role: "Denetleme Kurulu" },
  { id: 3, name: "Fatih Gür", role: "Denetleme Kurulu" },
];

export const values = [
  {
    icon: "Heart",
    title: "Geçmişe Bağlılık",
    description:
      "Trabzon'un zengin kültürünü, hafızasını ve geleneklerini yaşatmak en temel sorumluluğumuzdur.",
  },
  {
    icon: "Star",
    title: "Geleceğe Umut",
    description:
      "Gençlerimize eğitim, mentorluk ve kariyer desteği sunarak yarını birlikte inşa ediyoruz.",
  },
  {
    icon: "Shield",
    title: "Saygı",
    description:
      "Büyüklerimize, kurucularımıza ve ortak değerlerimize derin bir saygıyla bağlıyız.",
  },
  {
    icon: "Users",
    title: "Kapsayıcılık",
    description:
      "Kadın, erkek, genç, yaşlı; Trabzon'a gönül veren herkes bu çatının altında karşılık bulur.",
  },
];
